let cached = null;
let inflight = null;

/**
 * Fetch form registry (CO/GA/TN) from public/form-registry.json.
 * @returns {Promise<object|null>}
 */
export const loadFormRegistry = async () => {
  if (cached) return cached;
  if (!inflight) {
    inflight = fetch(`${process.env.PUBLIC_URL || ""}/form-registry.json`)
      .then((r) => {
        if (!r.ok) throw new Error(`form-registry.json HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        cached = data;
        return cached;
      })
      .catch((err) => {
        console.warn("Form registry unavailable; validation disabled.", err);
        cached = null;
        return null;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export const clearFormRegistryCache = () => {
  cached = null;
  inflight = null;
};
